
function getPOSGeneralName ({ tenantSettings, lowercase, plural, long }) {
	let name = 'Machine';

	if (plural) {
		if (tenantSettings?.usesMarkets) {
			name = long ? 'Points of sale' : 'POS';
		}
		else {
			name = 'Machines';
		}
	}
	else {
		if (tenantSettings?.usesMarkets) {
			name = long ? 'Point of sale' : 'POS';
		}
	}

	if (lowercase && (!tenantSettings?.usesMarkets || long)) {
		name = name.toLowerCase();
	}

	return name;
}

export default getPOSGeneralName;
